import { render, staticRenderFns } from "./ModalUploadPromokit.vue?vue&type=template&id=1fb8ccd9&"
import script from "./ModalUploadPromokit.vue?vue&type=script&lang=js&"
export * from "./ModalUploadPromokit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports